module.exports = __webpack_public_path__ + "img/total_look.cover.f5ea5592.jpg";